import styles from "../css/LearningDailyCard.module.css";
import LearningHistoryTermsResult from "../model/LearningHistoryTerms";
import { useTranslation } from "react-i18next";

import { ReactComponent as TitleIcon } from "../../../img/iconImgAllDailyTargetLearning.svg";
import { ReactComponent as FlameIcon } from "../../../img/iconImgAllFlame.svg";
import { toDecimalString } from "../../common/strings";
import classNames from "classnames";

interface LearningDailyCardProps {
  showing: boolean;
  value?: LearningHistoryTermsResult;
  onClick: (event: React.MouseEvent<HTMLDivElement>) => void;
}

export default function LearningDailyCard(props: LearningDailyCardProps) {
  const { t } = useTranslation();

  if (props.value === undefined) return null;

  const learnedTermCountDecimalString = toDecimalString(
    props.value.correctTermsCount
  );

  const goalCountDecimalString = toDecimalString(props.value.goalCount);

  const progress = Math.floor(
    (props.value.correctTermsCount / props.value.goalCount) * 100
  );

  const finalProgress = progress > 100 ? 100 : progress;

  const valueItemValueText = classNames(styles.valueItemValueText, {
    [styles.valueItemValueTextZero]: finalProgress === 0,
    [styles.valueItemValueTextFull]: finalProgress === 100,
  });

  const flmaeImage = classNames(styles.flameImage, {
    [styles.flameImageDisabled]: finalProgress < 100,
    [styles.flameImageActive]: finalProgress === 100,
  });

  if (props.showing !== false) return null;

  return (
    <>
      <button
        type="button"
        className={styles.container}
        onClick={(e) =>
          props.onClick(e as unknown as React.MouseEvent<HTMLDivElement>)
        }
      >
        <div className={styles.topContainer}>
          <div className={styles.titleContainer}>
            <TitleIcon className={styles.titleImage} />
            <span className={styles.titleText}>
              {t("LearningTodayGoalCardTitle")}
            </span>
          </div>

          <FlameIcon className={flmaeImage} />
        </div>

        <div className={styles.valueContainer}>
          <div className={styles.valueItemContainer}>
            <span className={styles.valueItemTitleText}>
              {t("LearningDailyTargetLeanredTermTitle")}
            </span>
            <span className={styles.valueItemValueText}>
              {learnedTermCountDecimalString}
            </span>
          </div>

          <div className={styles.valueItemContainer}>
            <span className={styles.valueItemTitleText}>
              {t("LearningDailyTargetGoalTermTitle")}
            </span>
            <span className={styles.valueItemValueText}>
              {goalCountDecimalString}
            </span>
          </div>

          <div className={styles.valueItemContainer}>
            <span className={styles.valueItemTitleText}>
              {t("LearningDailyTargetProgressTitle")}
            </span>
            <span className={valueItemValueText}>{finalProgress}%</span>
          </div>
        </div>
      </button>
    </>
  );
}
